/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
let NODE_ENV = 'production'
let apiUrl = ''
let wssUrl = ''
let uniacid = 1
let pathname = window.location.pathname;
let start = pathname.indexOf('/addons/');
let basepath = pathname.substring(0, start);
let siteRoot = window.location.protocol + '//' + window.location.host + basepath;
if(NODE_ENV == 'development') {
	apiUrl = '/api';
	wssUrl = 'ws://127.0.0.1:2345'
}else if(NODE_ENV == 'production'){
	apiUrl = siteRoot + '/app/wxapp.php';
	let siteRootBase = siteRoot;
	siteRootBase = siteRootBase.replace('https://', '');
	siteRootBase = siteRootBase.replace('http://', '');
	wssUrl = 'wss://' + siteRootBase + '/wss';
	console.log(apiUrl)
}
window.siteRoot = siteRoot
export {
	apiUrl,
	wssUrl,
	siteRoot,
	NODE_ENV
}




// WEBPACK FOOTER //
// ./src/config/env.js